<template>
  <div>
    <el-row :gutter="5">
      <el-form ref="params" :model="params">
        <el-col :span="4" :xs="24">
          <el-form-item prop="name">
            <el-input v-model="params.name" placeholder="输入子代理名称"/>
          </el-form-item>
        </el-col>
        <el-col :span="4" :xs="24">
          <el-form-item prop="name">
            <el-input v-model="params.phone" placeholder="输入子代理手机号"/>
          </el-form-item>
        </el-col>
        <el-col :span="2" :xs="12">
          <el-button type="primary" @click="search">搜索</el-button>
        </el-col>
        <el-col :span="2" :xs="12">
          <el-button plain type="success" @click="reset">重置</el-button>
        </el-col>
        <el-col :span="3" :xs="12" class="xs-mp-10">
          <el-button type="primary" @click="addDialog = true">新建子代理</el-button>
        </el-col>
      </el-form>
    </el-row>
    <el-table v-loading="loadTable" :data="records" stripe @sort-change="sort_change" :default-sort = "{prop: 'id', order: 'descending'}">
      <el-table-column fixed label="姓名" prop="name"/>
      <el-table-column label="ID" prop="id" sortable="custom"/>
      <el-table-column label="手机号" prop="phone"/>
      <el-table-column label="联系地址" prop="address"/>
      <el-table-column label="加盟时间" prop="creatTime">
        <template #default="scope">
          {{ timeFormat(scope.row.creatTime / 1000) }}
        </template>
      </el-table-column>
      <el-table-column label="抽成比例" prop="baseAgentDividendRaton">
        <template #default="scope">
          {{ scope.row.baseAgentDividendRaton + '%' }}
        </template>
      </el-table-column>
      <el-table-column label="余额" prop="money"/>
      <el-table-column label="操作" width="180">
        <template #default="scope">
          <el-button size="mini" type="success" @click="open(scope.row)">编辑</el-button>
          <!-- <el-button size="mini" @click="skip">授权电站</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <page :current="current" :size="size" :total="total"/>
    <el-dialog :fullscreen="dialogFullscreen" :visible.sync="addDialog" title="新建子代理">
      <el-form ref="addForm" :model="addForm" :rules="rules" label-width="auto">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="addForm.name"/>
        </el-form-item>
        <el-form-item label="手机号" prop="phone" sortable="custom">
          <el-input v-model="addForm.phone" maxlength="11"/>
        </el-form-item>
        <el-form-item label="联系地址" prop="address">
          <el-cascader v-model="address" :options="provinceAndCityData" size="large"
                       @change="addressChange"/>
        </el-form-item>
        <el-form-item label="登录密码" prop="pwd">
          <el-input v-model="addForm.pwd" maxlength="10" show-password/>
        </el-form-item>
        <el-form-item label="父运营商抽成比例" prop="baseAgentDividendRaton">
          <el-input v-model.number="addForm.baseAgentDividendRaton">
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
        <el-form-item label="提现是否需要审核">
          <el-switch
              v-model="addForm.withdrawNeedCheck"
              active-text="需要审核"
              active-value="1"
              inactive-text="不需要审核"
              inactive-value="0"/>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="addDialog = false">取 消</el-button>
        <el-button type="primary" @click="addAgency">提交</el-button>
      </div>
    </el-dialog>
    <edit-child-agent-dialog :dialog="editChildAgentDialog" :row="row"/>
  </div>
</template>

<script>
import timeMixin from "@/mixin/timeMixin";
import searchMixin from "@/mixin/searchMixin";
import pageMixin from "@/mixin/pageMixin";
import dialogMixin from "@/mixin/dialogMixin";
import {checkPhone, oneToHundred} from "@/utils/check";
import agentAddChildAgent from "@/api/user/agent-manage/agentAddChildAgent";
import resDispose from "@/mixin/resDisposeMixin";
import createdMixin from "@/mixin/createMixin";
import agentGetChildAgentListByPage from "@/api/user/agent-manage/agentGetChildAgentListByPage";
import {CodeToText, provinceAndCityData} from "element-china-area-data";
import editChildAgentDialog from "@/components/OperatorsManage/AgencyList/editChildAgentDialog";
import Page from "@/components/Page";
import formatPhone from "@/mixin/formatPhoneMixin";

export default {
  name: "AgencyList",
  components: {editChildAgentDialog, Page},
  mixins: [pageMixin, timeMixin, searchMixin, dialogMixin, resDispose, createdMixin],
  data() {
    return {
      row: undefined,
      editChildAgentDialog: false,
      provinceAndCityData: provinceAndCityData,
      rules: {
        name: [{required: true, message: '请输入运营商姓名'}],
        pwd: [{required: true, message: '请输入密码'}, {min: 6, max: 20, message: '长度在6到20个字符'}],
        withdrawPwd: [{required: true, message: '请输入密码'}, {min: 6, max: 20, message: '长度在6到20个字符'}],
        address: [
          {required: true, message: '请选着地址'},
        ],
        phone: checkPhone,
        dividendRatio: [
          {required: true, message: '请输入父运营商抽成比例'},
          {type: 'number', message: '必须为数字值'},
          {required: true, validator: oneToHundred}
        ],
      },
      address: undefined,
      addForm:
          {
            baseAgentDividendRaton: 0,
            address: undefined,
            pwd: undefined,
            withdrawNeedCheck: 1,
            withdrawPwd: undefined,
            name: undefined,
            phone: undefined
          },
      addDialog: false,
      params: {
        name: undefined,
        phone: undefined,
        pageNum: undefined,
        size: 10,
        sortName: 'id',
        sortType: 'DESC',
      },
      records: [],
    }
  },
  watch:{
    'params.phone':{
      handler(){
        this.params.phone = formatPhone(this.params.phone)
      }
    }
  },
  methods: {
    reset(){
      this.params.name = undefined
      this.params.phone = undefined
      if (this.time) {
        delete this.params.startTime;
        delete this.params.endTime;
        this.time = [];
        this.current = 1;
      }
      this.fetchData();
    },
    sort_change(e) {
      this.params.sortName = e.prop
      this.params.sortType = e.order == 'descending' ? 'DESC' : 'ASC'
      if (e.order == null) {
        this.params.sortName = null
        this.params.sortType = null
      }
      console.log(this.params.sortName)
      // console.log(this.params.sortType)
      this.fetchData()
    },
    open(row) {
      this.row = row;
      this.editChildAgentDialog = true;
    },
    addressChange(arr) {
      this.addForm.address = CodeToText[arr[0]] + "-" + CodeToText[arr[1]];
    },
    fetchData() {
      this.loadTable = true;
      this.params.pageNum = this.current;
      agentGetChildAgentListByPage(this.params, this.current, this.size).then(res => {
        this.total = res.data.total;
        this.records = res.data.records;
      }).finally(() => {
        this.loadTable = false;
      });
    },
    addAgency() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          agentAddChildAgent(this.addForm).then(res => {
            this.resDispose({
              res,
              success: () => {
                this.$refs['addForm'].resetFields();
                this.fetchData();
                this.addDialog = false;
              }
            })
          })
        }
      })
    },
    skip() {
      this.$router.push({
        name: "未绑定设备"
      })
    }
  },
}
</script>
